import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as Yup from "yup";

// formik components
import { Formik, Form, Field, FieldArray } from "formik";
import Swal from "sweetalert2";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { Box, CircularProgress, IconButton } from "@mui/material";

import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { addNewPlaceApi, updatePlaceApi } from "api/places";

import { v4 as uuidv4 } from "uuid";

function CinemaSelectedSieges({ isEdite, openModalItemData, newSiegeData, selectedTimeIndex }) {
  const [isOnlineChecked, setIsOnlineChecked] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const validationSchema = Yup.object().shape({
    eventSiege: Yup.array()
      .of(
        Yup.object().shape({
          name: Yup.string().required("Saisir le nom de siège"),
          price: Yup.number().required("Saisir le prix").positive("Le prix doit être positif"),
          numberOfPlaces: Yup.number()
            .required("Saisir le nombre limite de places")
            .min(0, "Le nombre de places doit être supérieur ou égal à 0"),
          isSoldOut: Yup.boolean().required("Indiquer si le siège est Soldout"),
        })
      )
      .required("Vous devez ajouter au moins une siège"),
  });

  useEffect(() => {
    getInitialValue();
  }, []);

  const getInitialValue = () => {
    try {
      if (isEdite) {
        setIsOnlineChecked(openModalItemData?.isOnline);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddNewEventSiege = async (value) => {
    try {
      newSiegeData(value.eventSiege, selectedTimeIndex);
    } catch (err) {
      Swal.fire({
        title: "Erreur",
        text: "Une erreur est survenue lors de la mise à jour de la liste des sièges.",
        icon: "error",
      });
    }
  };

  const handleUpdateEventPlace = async (value) => {
    try {
      // Implement update logic if needed
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <MDBox>
        <Grid container justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
          <Grid item xs={12}>
            <Formik
              initialValues={{
                eventSiege: openModalItemData ? openModalItemData : [],
              }}
              validationSchema={validationSchema}
              onSubmit={async (values) => {
                isEdite ? handleUpdateEventPlace(values) : handleAddNewEventSiege(values);
              }}
            >
              {({ values, setFieldValue, dirty }) => (
                <Form autoComplete="off">
                  <Card sx={{ height: "100%" }}>
                    <MDBox p={3}>
                      <MDBox>
                        <FieldArray name="eventSiege">
                          {({ push, remove }) => (
                            <>
                              {values.eventSiege.map((place, index) => (
                                <Grid container spacing={1} key={index} alignItems="center">
                                  <Grid item xs={12} sm={3} mb={1.2}>
                                    <Field name={`eventSiege[${index}].name`}>
                                      {({ field, meta }) => (
                                        <>
                                          <MDInput
                                            {...field}
                                            label="Siège"
                                            size="large"
                                            fullWidth
                                            error={meta.error}
                                            success={!meta.error && meta.touched}
                                          />
                                          {meta.touched && meta.error && (
                                            <MDTypography
                                              component="div"
                                              variant="caption"
                                              color="error"
                                              fontWeight="regular"
                                            >
                                              {meta.error}
                                            </MDTypography>
                                          )}
                                        </>
                                      )}
                                    </Field>
                                  </Grid>

                                  <Grid item xs={12} sm={2} mb={1.2}>
                                    <Field name={`eventSiege[${index}].price`}>
                                      {({ field, meta }) => (
                                        <>
                                          <MDInput
                                            {...field}
                                            type="number"
                                            label="Prix"
                                            size="large"
                                            fullWidth
                                            error={meta.error}
                                            success={!meta.error && meta.touched}
                                          />
                                          {meta.touched && meta.error && (
                                            <MDTypography
                                              component="div"
                                              variant="caption"
                                              color="error"
                                              fontWeight="regular"
                                            >
                                              {meta.error}
                                            </MDTypography>
                                          )}
                                        </>
                                      )}
                                    </Field>
                                  </Grid>

                                  <Grid item xs={12} sm={2} mb={1.2}>
                                    <Field name={`eventSiege[${index}].numberOfPlaces`}>
                                      {({ field, meta }) => (
                                        <>
                                          <MDInput
                                            {...field}
                                            type="number"
                                            label="Nombre des places"
                                            size="large"
                                            fullWidth
                                            error={meta.error}
                                            success={!meta.error && meta.touched}
                                          />
                                          {meta.touched && meta.error && (
                                            <MDTypography
                                              component="div"
                                              variant="caption"
                                              color="error"
                                              fontWeight="regular"
                                            >
                                              {meta.error}
                                            </MDTypography>
                                          )}
                                        </>
                                      )}
                                    </Field>
                                  </Grid>

                                  <Grid item xs={12} sm={3} mb={1.2}>
                                    <Field name={`eventSiege[${index}].isSoldOut`}>
                                      {({ field }) => (
                                        <FormControlLabel
                                          control={
                                            <Switch
                                              {...field}
                                              checked={field.value}
                                              onChange={(e) =>
                                                setFieldValue(field.name, e.target.checked)
                                              }
                                            />
                                          }
                                          label="Soldout"
                                        />
                                      )}
                                    </Field>
                                  </Grid>

                                  <Grid item xs={12} sm={2}>
                                    <IconButton onClick={() => remove(index)} color="error">
                                      <DeleteIcon fontSize="30px" />
                                    </IconButton>
                                  </Grid>
                                </Grid>
                              ))}
                              <MDButton
                                type="button"
                                onClick={() =>
                                  push({
                                    name: "",
                                    price: null,
                                    numberOfPlaces: null,
                                    isSoldOut: false,
                                    id: uuidv4(),
                                  })
                                }
                                variant="text"
                                color="success"
                                startIcon={<AddIcon />}
                              >
                                Ajouter un siège
                              </MDButton>
                            </>
                          )}
                        </FieldArray>
                        {isLoaded ? (
                          <Box sx={{ display: "flex" }}>
                            <CircularProgress />
                          </Box>
                        ) : dirty ? (
                          <MDButton type="submit" variant="gradient" color="dark">
                            Modifier
                          </MDButton>
                        ) : null}
                      </MDBox>
                    </MDBox>
                  </Card>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </MDBox>
    </div>
  );
}

CinemaSelectedSieges.propTypes = {
  isEdite: PropTypes.bool,
  openModalItemData: PropTypes.array,
  newSiegeData: PropTypes.func,
  selectedTimeIndex: PropTypes.number,
};

export default CinemaSelectedSieges;
